//import NPM, LIB
import React, { useState, useEffect } from "react";
import Moment from "moment";
import { sub, format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import Lightbox from "react-image-lightbox";
import MicroModal from "micromodal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBrLocale from "date-fns/locale/pt-BR";
import ReactHtmlParser from "react-html-parser";

//import ACTIONS
import {
  dbfileSize,
  DetailsMarkstarida,
  GetInteractionsModal,
} from "../../../../actions";
import testJson from "../../../../actions/testJson";
import convertUnicodeEmoji from "../../../../actions/convertUnicodeEmoji";

//import COMPONENT
import Typography from "../../../Typography";
import CommentImage from "../../../CommentImage/CommentImage";
import InteractionChat from "../../../InteractionChat/InteractionChat";
import Loading from "../../../Loading";

//import NPM, LIB
import "../../../../build/css/modal.css";
import "./messagefav-modal.css";

//import IMG,SVG
import JPG from "../../../../build/images/jpg-file.png";
import XLS from "../../../../build/images/media-icon.png";
import PDF from "../../../../build/images/pdf-file.png";
import MP3 from "../../../../build/images/mp3-file.png";
import AVI from "../../../../build/images/avi-file.png";
import { ReactComponent as IconDoc } from "../../../../build/images/attendanceIcons/document-text.svg";
import { ReactComponent as IconCalendar } from "../../../../build/images/Calendar-2.svg";
import { ReactComponent as IconTimer } from "../../../../build/images/timer.svg";
import { ReactComponent as IconMessageNull } from "../../../../build/images/messages-3.svg";

const { connection_platform } = require("../../../../services/api");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  // if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

// let detailsMarkstar = [];
// let now = Moment().subtract(1, "month");
// let dateinitsearchfavorite = now.format("YYYY-MM-DD");
// let dateendsearchfavorite = Moment().format("YYYY-MM-DD");

let dateinitsearchfavorite = sub(new Date(), {
  months: 1,
});
let dateendsearchfavorite = new Date();
let auxdia = "";
let dia = "";

export default function NewMessageFavoriteModal(props) {
  const dispatch = useDispatch();
  const InfoUsers = useSelector((state) => state.informationusers);
  const MessageFavoritesData = useSelector((state) => state.detailsmarkstars);
  const contactId = useSelector((state) => state.atendimento);
  const infoModal = useSelector((state) => state.interactionsmodal);

  const [isOpen, setIsOpen] = useState(false);
  const [urlimage, setUrlImage] = useState("");
  const [dataInitial, setDataInitial] = useState(dateinitsearchfavorite);
  const [dataFinal, setDataFinal] = useState(dateendsearchfavorite);
  const [loading, setLoading] = useState(false);
  const [ContactId, setContactId] = useState({});
  const [termText, setTermText] = useState("");
  const [detailsMarkstar, setDetailsMarkstar] = useState([]);

  const buttonSearchMarkstar = () => {
    let erro = 0;
    // const datainit = document.getElementById("date_init_search_favorite").value;
    // const datafim = document.getElementById("date_fim_search_favorite").value;
    const datainit = format(dataInitial, "yyyy-MM-dd");
    const datafim = format(dataFinal, "yyyy-MM-dd");

    let comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") erro = 1;

    if (datafim == "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      setLoading(true);
      dispatch(DetailsMarkstarida(datainit, datafim, ContactId.telefone));
    }
  };

  function exitModal(e, modal) {
    // if (originModal === "contacts") {
    //   MicroModal.close("modal__historico-atendimento-details");
    //   MicroModal.show("modal__agenda");
    // } else if (originModal === "") {
    MicroModal.close(modal);
    dispatch(GetInteractionsModal("", ""));
    setDataInitial(dateinitsearchfavorite);
    setDataFinal(dateendsearchfavorite);
    // }
  }

  const VerifierImage = (urlimage) => {
    setIsOpen(true);
    setUrlImage(urlimage);
    MicroModal.close("modal__mensagens-favoritas_manager_new");
  };

  const CloseImage = () => {
    setIsOpen(false);
    setUrlImage("");
    MicroModal.show("modal__mensagens-favoritas_manager_new");
  };

  function createJSON(item) {
    if (item) {
      var mensagem_tratada = item.replace(/¿/gi, "\n");
      mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      let valor = 1;
      try {
        mensagem_tratada =
          '{"' +
          valor +
          '": [{"mensagem_tratada":"' +
          mensagem_tratada +
          '"}]}';
        var obj = JSON.parse(mensagem_tratada);
        mensagem_tratada = obj[1][0].mensagem_tratada;
      } catch (e) {
        mensagem_tratada = item;
      }
      return mensagem_tratada;
    }
  }

  function renderMedia(link, filesize) {
    let separador = link.split(".");
    let get_name = separador[0].split("/");
    let verificarexistencia = "";

    let fileObject = {
      name: get_name[get_name.length - 1],
      size: "",
      type: "image",
      path_arquivos: link,
      extension: separador[1].toLowerCase(),
      id: "",
    };
    switch (separador[1]) {
      case "jpeg":
      case "png":
      case "jpg":
        return (
          <div className="message left msg-fav__media">
            <div className="bubble-media">
              <div
                className="bubble-media__image"
                onClick={() =>
                  VerifierImage(
                    connection_platform.type_connect + "://" + ipcurrent + link,
                    "dmark"
                  )
                }
              >
                {isOpen && (
                  <Lightbox
                    mainSrc={urlimage}
                    onCloseRequest={() => CloseImage("dmark")}
                  />
                )}
                <img
                  src={
                    connection_platform.type_connect + "://" + ipcurrent + link
                  }
                  alt=""
                />
              </div>
              {/* <CommentImage content={[{ file: fileObject }]} /> */}
              <div className="bubble-media__mediaInfo">
                <span className="bubble-media__fileType">
                  <img className="bubble-media__fileIcon" src={JPG} alt="" />
                </span>
                <span className="bubble-media__fileName">
                  <p className="bubble-media__text">Nome do Arquivo</p>
                  <br />
                  <div className="fileinfo__bar">
                    <span className="fileinfo__size">
                      {dbfileSize(filesize)}
                    </span>{" "}
                    • <span className="fileinfo__type">{""}</span>
                  </div>
                </span>
                {(() => {
                  if (InfoUsers.permdownload === true) {
                    return (
                      <div className="bubble-media__download">
                        <a
                          href={
                            connection_platform.type_connect +
                            "://" +
                            ipcurrent +
                            link
                          }
                          target="_blank"
                          download
                          className="bubble-media__btnDownload"
                        >
                          <i className="material-icons">get_app</i>
                        </a>
                      </div>
                    );
                  }
                })()}
              </div>
            </div>
          </div>
        );
      case "pdf":
        return (
          <div className="message left msg-fav__media">
            <div className="bubble-media">
              <div className="bubble-media__mediaInfo">
                <span className="bubble-media__fileType">
                  <img className="bubble-media__fileIcon" src={PDF} alt="" />
                </span>
                <span className="bubble-media__fileName">
                  <p className="bubble-media__text">Nome do Arquivo</p>
                  <br />
                  <div className="fileinfo__bar">
                    <span className="fileinfo__size">
                      {dbfileSize(filesize)}
                    </span>{" "}
                    • <span className="fileinfo__type">{""}</span>
                  </div>
                </span>
                {(() => {
                  if (InfoUsers.permdownload === true) {
                    return (
                      <div className="bubble-media__download">
                        <a
                          href={
                            connection_platform.type_connect +
                            "://" +
                            ipcurrent +
                            link
                          }
                          target="_blank"
                          download
                          className="bubble-media__btnDownload"
                        >
                          <i className="material-icons">get_app</i>
                        </a>
                      </div>
                    );
                  }
                })()}
              </div>
            </div>
          </div>
        );
      case "xls":
      case "xlsx":
      case "xlsm":
      case "doc":
      case "docx":
      case "ppt":
      case "pptx":
        return (
          <div className="message left msg-fav__media">
            <div className="bubble-media">
              <div className="bubble-media__mediaInfo">
                <span className="bubble-media__fileType">
                  <img className="bubble-media__fileIcon" src={XLS} alt="" />
                </span>
                <span className="bubble-media__fileName">
                  <p className="bubble-media__text">Nome do Arquivo</p>
                  <br />
                  <div className="fileinfo__bar">
                    <span className="fileinfo__size">
                      {dbfileSize(filesize)}
                    </span>{" "}
                    • <span className="fileinfo__type">{""}</span>
                  </div>
                </span>
                {(() => {
                  if (InfoUsers.permdownload === true) {
                    return (
                      <div className="bubble-media__download">
                        <a
                          href={
                            connection_platform.type_connect +
                            "://" +
                            ipcurrent +
                            link
                          }
                          target="_blank"
                          download
                          className="bubble-media__btnDownload"
                        >
                          <i className="material-icons">get_app</i>
                        </a>
                      </div>
                    );
                  }
                })()}
              </div>
            </div>
          </div>
        );
      case "wav":
      case "mp3":
      case "ogg":
      case "mpeg":
        return (
          <div className="message left msg-fav__media">
            <div className="bubble-media">
              <div className="bubble-media__playerBar">
                <audio controls>
                  <source
                    src={
                      connection_platform.type_connect +
                      "://" +
                      ipcurrent +
                      link
                    }
                    type="audio/ogg"
                  />
                  <source
                    src={
                      connection_platform.type_connect +
                      "://" +
                      ipcurrent +
                      link
                    }
                    type="audio/mpeg"
                  />
                  Your browser.
                </audio>
              </div>
              <div className="bubble-media__mediaInfo">
                <span className="bubble-media__fileType">
                  <img className="bubble-media__fileIcon" src={MP3} alt="" />
                </span>
                <span className="bubble-media__fileName">
                  <p className="bubble-media__text">Nome do Arquivo</p>
                  <br />
                  <div className="fileinfo__bar">
                    <span className="fileinfo__size">
                      {dbfileSize(filesize)}
                    </span>{" "}
                    • <span className="fileinfo__type">{""}</span>
                  </div>
                </span>
                {(() => {
                  if (InfoUsers.permdownload === true) {
                    return (
                      <div className="bubble-media__download">
                        <a
                          href={
                            connection_platform.type_connect +
                            "://" +
                            ipcurrent +
                            link
                          }
                          target="_blank"
                          download
                          className="bubble-media__btnDownload"
                        >
                          <i className="material-icons">get_app</i>
                        </a>
                      </div>
                    );
                  }
                })()}
              </div>
            </div>
          </div>
        );
      case "mp4":
        return (
          <div className="message left msg-fav__media">
            <div className="bubble-media">
              <div className="bubble-media__video">
                <video className="bubble-media__video-frame" controls>
                  <source
                    className="bubble-media__video-file"
                    src={
                      connection_platform.type_connect +
                      "://" +
                      ipcurrent +
                      link
                    }
                    type="video/mp4"
                  />
                  Seu navegador nao suporta esse tipo de arquivo.
                </video>
              </div>
              <div className="bubble-media__mediaInfo">
                <span className="bubble-media__fileType">
                  <img className="bubble-media__fileIcon" src={AVI} alt="" />
                </span>
                <span className="bubble-media__fileName">
                  <p className="bubble-media__text">Nome do Arquivo</p>
                  <br />
                  <div className="fileinfo__bar">
                    <span className="fileinfo__size">
                      {dbfileSize(filesize)}
                    </span>{" "}
                    • <span className="fileinfo__type">{""}</span>
                  </div>
                </span>
                {(() => {
                  if (InfoUsers.permdownload === true) {
                    return (
                      <div className="bubble-media__download">
                        <a
                          href={
                            connection_platform.type_connect +
                            "://" +
                            ipcurrent +
                            link
                          }
                          target="_blank"
                          download
                          className="bubble-media__btnDownload"
                        >
                          <i className="material-icons">get_app</i>
                        </a>
                      </div>
                    );
                  }
                })()}
              </div>
            </div>
          </div>
        );
      default:
        break;
    }
  }

  function handleFileObject(dmark, link) {
    let separador = link ? link.split(".") : dmark.mensagem.split(".");
    let typenameMsg = "txt";
    let get_name = separador[0].split("/");
    switch (separador[1].toLowerCase()) {
      case "jpeg":
      case "png":
      case "jpg": {
        typenameMsg = "image";
        break;
      }
      case "pdf":
      case "xls":
      case "xlsx":
      case "xlsm":
      case "txt":
      case "doc":
      case "docx":
      case "ppt":
      case "pptx":
      case "ppsx": {
        typenameMsg = "document";
        break;
      }
      case "wav":
      case "mp3":
      case "ogg":
      case "mpeg": {
        typenameMsg = "audio";
        break;
      }
      case "mp4": {
        typenameMsg = "video";
        break;
      }
      default:
        typenameMsg = "document";
        break;
    }

    return {
      name: get_name[get_name.length - 1],
      size: link ? "" : dmark.filesize,
      type: typenameMsg,
      path_arquivos: link ? link : dmark.mensagem,
      extension: separador[1].toLowerCase(),
      id: dmark.id,
    };
  }

  function handleMessageFav(dmark) {
    let positmessage1 = "";
    let positmessage2 = "";
    if (dmark.is_from_agent === true) {
      positmessage1 = " right";
    }
    if (dmark.data_markstar != auxdia) {
      dia = dmark.data_markstar;
      auxdia = dmark.data_markstar;
    } else {
      auxdia = dmark.data_markstar;
      dia = "";
    }
    let nameUser = createJSON(ContactId.cliente);

    if (dmark.is_from_agent || dmark.mon_type_id !== 0) {
      if (dmark.username) {
        nameUser =
          InfoUsers.username === dmark.username ? "Você" : dmark.username;
      } else {
        nameUser = "Você";
      }
    }
    if (dmark.mimetypeid == "1") {
      return (
        <InteractionChat
          key={dmark.id}
          index={dmark.id}
          id={dmark.id}
          inputSearch={""}
          text={dmark.mensagem}
          type={""}
          date={{
            dia: dia,
            horaEnvio: dmark.hora_markstar.slice(
              0,
              dmark.hora_markstar.length - 3
            ),
            statusmsg: dmark.statusmsg,
          }}
          attachment={dmark.file}
          size={dmark.filesize}
          mimetypeId={dmark.mimetypeid}
          mimetype={dmark.mimetype}
          typeName={dmark.typename}
          name={nameUser}
          alwaysFav
          direction={
            dmark.is_from_agent === true && dmark.mon_type_id === 0
              ? "right"
              : "left"
          }
          buttons={dmark.buttons}
          botId={dmark.botid}
          reply={dmark.reply}
          buttonResponse={dmark.buttonResponse}
          location={dmark.location}
          allInfo={dmark}
          InfoUsers={InfoUsers}
          ContactId={ContactId}
        />
      );
    } else {
      if (dmark.mimetypeid == "2") {
        if (testJson(dmark.mensagem) === true) {
          let json = JSON.parse(dmark.mensagem);
          let options = json.options;
          let i = 1;
          var opcoes = [];
          for (i in options) {
            opcoes.push(i + " - " + options[i][1]);
          }
          return (
            <li className={"msg-fav__mp-item" + positmessage1}>
              {dmark.mensagem}
            </li>
          );
        } else {
          return (
            <li className={"msg-fav__mp-item" + positmessage1}>
              {dmark.mensagem}
            </li>
          );
        }
      } else if (
        dmark.mimetypeid == "3" ||
        dmark.mimetypeid == "5" ||
        dmark.mimetypeid > "6"
      ) {
        if (testJson(dmark.mensagem) === true) {
          const cleanedJsonString = dmark.mensagem.replace(
            /\\(?!["\\/bfnrtu])/g,
            ""
          );
          let json = JSON.parse(cleanedJsonString);
          let buttons = "";
          let botid = json.botid ? json.botid : "";
          let fileObject = "";
          let msgtext = dmark.mensagem;
          let contactInfo = "";

          if (json.address) {
            dmark.location = {
              latitude: json.latitude,
              longitude: json.longitude,
              nomeEndereco: json.name,
              endereco: json.address,
            };
          }

          if (json.buttons) {
            buttons = json.buttons;
          } else if (json.items) {
            buttons = json.items;
          } else if (json.HSM_BUTTONS) {
            let buttonsFormated = [];
            if (json.HSM_BUTTONS.buttons) {
              const buttons = json.HSM_BUTTONS.buttons;
              for (const btn of buttons) {
                const objBtn = {
                  payload: btn.index,
                  text: btn.parameters[0].text,
                };

                buttonsFormated.push(objBtn);
              }
            } else {
              const buttons = json.HSM_BUTTONS;
              for (const btn of buttons) {
                const objBtn = {
                  payload: btn.payload.index,
                  text: btn.payload.value,
                };

                buttonsFormated.push(objBtn);
              }
            }

            buttons = buttonsFormated;
          } else if (json.name && json.name.formattedName) {
            contactInfo = json;
            msgtext = "";
          }

          if (json.link) {
            fileObject = handleFileObject(dmark, json.link);
          } else if (json.FILEPATH) {
            fileObject = handleFileObject(dmark, json.FILEPATH);
          }

          if (parseInt(json.MIMETYPE) === 30) {
            msgtext = json.MSG;
          } else if (
            parseInt(json.mimetype) >= 33 &&
            parseInt(json.mimetype) <= 37
          ) {
            if (json.header) {
              msgtext = `*${json.header}*\\r\\n${json.msg}`;
            } else {
              msgtext = json.msg;
            }
          } else if (json.address) {
            msgtext = json.address;
          } else if (json.HSM_BUTTONS) {
            msgtext = json.URL;
          }

          return (
            <InteractionChat
              key={dmark.id}
              index={dmark.id}
              id={dmark.id}
              inputSearch={""}
              text={msgtext}
              type={""}
              date={{
                dia: dia,
                horaEnvio: dmark.hora_markstar.slice(
                  0,
                  dmark.hora_markstar.length - 3
                ),
                statusmsg: dmark.statusmsg,
              }}
              attachment={fileObject}
              size={dmark.filesize}
              mimetypeId={dmark.mimetypeid}
              mimetype={dmark.mimetype}
              typeName={dmark.typename}
              name={nameUser}
              alwaysFav
              direction={
                dmark.is_from_agent === true && dmark.mon_type_id === 0
                  ? "right"
                  : "left"
              }
              buttons={buttons}
              botId={botid}
              reply={dmark.reply}
              buttonResponse={dmark.buttonResponse}
              location={dmark.location}
              allInfo={dmark}
              InfoUsers={InfoUsers}
              ContactId={ContactId}
              contactInfo={contactInfo}
            />
          );
        } else {
          let fileObject = handleFileObject(dmark);

          return (
            <InteractionChat
              key={dmark.id}
              index={dmark.id}
              id={dmark.id}
              inputSearch={""}
              text={dmark.caption ? dmark.caption : ""}
              type={""}
              date={{
                dia: dia,
                horaEnvio: dmark.hora_markstar.slice(
                  0,
                  dmark.hora_markstar.length - 3
                ),
                statusmsg: dmark.statusmsg,
              }}
              attachment={fileObject}
              size={dmark.filesize}
              mimetypeId={dmark.mimetypeid}
              mimetype={dmark.mimetype}
              typeName={dmark.typename}
              name={nameUser}
              alwaysFav
              direction={
                dmark.is_from_agent === true && dmark.mon_type_id === 0
                  ? "right"
                  : "left"
              }
              buttons={dmark.buttons}
              botId={dmark.botid}
              reply={dmark.reply}
              buttonResponse={dmark.buttonResponse}
              location={dmark.location}
              allInfo={dmark}
              InfoUsers={InfoUsers}
              ContactId={ContactId}
            />
          );
        }
      }
    }
  }

  function isJson(item) {
    item = typeof item != "string" ? JSON.stringify(item) : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === "object" && item != null) {
      return true;
    }

    return false;
  }

  function tratarBOT(text) {
    let json = JSON.parse(text.replaceAll("\r\n", "\\n"));
    let options = json.options;
    if (parseInt(json.MIMETYPE) === 30) {
      return json.MSG;
    } else if (parseInt(json.mimetype) >= 33 && parseInt(json.mimetype) <= 37) {
      if (json.header) {
        return `*${json.header}*\\r\\n${json.msg}`;
      } else {
        return json.msg;
      }
    } else if (json.address) {
      return json.address;
    } else if (json.HSM_BUTTONS) {
      return json.URL;
    }

    return text;
  }

  const commentFilter = (comment) => {
    if (termText) {
      const mensagemTratada = isJson(comment.mensagem)
        ? tratarBOT(comment.mensagem)
        : comment.mensagem;
      const commentFilter = mensagemTratada
        .toLowerCase()
        .includes(termText.toLowerCase());

      if (commentFilter) {
        return comment;
      } else {
        return;
      }
    } else {
      return comment;
    }
  };

  useEffect(() => {
    if (MessageFavoritesData.length != 0) {
      setDetailsMarkstar(MessageFavoritesData.detailsmarkstars);
      setLoading(false);
    }
  }, [MessageFavoritesData]);

  useEffect(() => {
    if (contactId && !infoModal.telefone) {
      setContactId(contactId);
    } else if (infoModal.telefone) {
      setContactId(infoModal);
    } else if (props.ContactId) {
      setContactId(props.ContactId);
    }
  }, [props.ContactId, infoModal, contactId]);

  return (
    <div
      className="modal micromodal-slide"
      id="modal__mensagens-favoritas-details"
      aria-hidden="true"
      role="dialog"
    >
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container modal-sizeInteractions"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__mensagens-favoritas__title"
          // data-micromodal-close
        >
          <header className="modal__header">
            <Typography.H2 color={"blue-selected-4"} weight={700}>
              Mensagens favoritas
            </Typography.H2>
            <button
              className="modal__close"
              aria-label="Close modal"
              data-micromodal-close
              onClick={(event) =>
                exitModal(event, "modal__mensagens-favoritas-details")
              }
            ></button>
          </header>
          <main
            className="modal__content"
            id="modal__mensagens-favoritas__content"
          >
            <div className="msg-fav__info">
              <Typography.H4 color={"blue-selected-5"}>
                {createJSON(ContactId.cliente)}
              </Typography.H4>

              <div className="modal__info-total">
                <IconDoc />
                <span className="msg-fav__info-text">
                  Total de{" "}
                  <span className="msg-fav__counter">
                    {detailsMarkstar.length}
                  </span>{" "}
                  mensagens
                </span>
              </div>
            </div>
            <div className="msg-fav__wrapper">
              <div className="msg-fav__mp">
                <div className="msg-fav__mp-ctrL">
                  <div className="msg-fav__mp-ctrL-container">
                    <div className={"msg-fav__mp-ctrL-search"}>
                      <Typography.H6 color={"gray-600"}>Mensagem</Typography.H6>
                      <input
                        type="text"
                        value={termText}
                        onChange={(event) => setTermText(event.target.value)}
                        className="msg-fav__search-input"
                        id="campopesquisartexto"
                        placeholder="Pesquisar..."
                      />
                    </div>
                    <div className="msg-fav__mp-date-container">
                      <div className="msg-fav__mp-date">
                        <div className="msg-fav__mp-date-wrapper">
                          <div className="modal_date-start">
                            <Typography.H6 color={"gray-600"}>
                              De:
                            </Typography.H6>
                            <LocalizationProvider
                              dateAdapter={AdapterDateFns}
                              adapterLocale={ptBrLocale}
                            >
                              <DatePicker
                                value={dataInitial}
                                onChange={(newValue) =>
                                  setDataInitial(newValue)
                                }
                                maxDate={dataFinal}
                              />
                            </LocalizationProvider>
                          </div>
                          <div className="modal_date-end">
                            <Typography.H6 color={"gray-600"}>
                              Até:
                            </Typography.H6>
                            <LocalizationProvider
                              dateAdapter={AdapterDateFns}
                              adapterLocale={ptBrLocale}
                            >
                              <DatePicker
                                value={dataFinal}
                                onChange={(newValue) => setDataFinal(newValue)}
                                minDate={dataInitial}
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className={`msg-fav__mp-btn btn-modals ${
                      loading ? "search-time" : ""
                    }`}
                    onClick={() => (loading ? null : buttonSearchMarkstar())}
                  >
                    Filtrar data
                  </button>
                </div>
                {/* <!-- END CTRL --> */}
                <div className="msg-fav__mp-result">
                  {loading ? (
                    <Loading.Paperplane fullPage={true} loadingModal />
                  ) : detailsMarkstar.length > 0 ? (
                    <ul className="msg-fav__mp-list">
                      {detailsMarkstar
                        .filter(commentFilter)
                        .map((dmark, i) => (() => handleMessageFav(dmark))())}
                    </ul>
                  ) : (
                    <div className="modal__nully">
                      <div className="modal__nully-icon">
                        <IconMessageNull />
                      </div>
                      <div className="modal__nully-text">
                        <Typography.H4 color={"black"}>
                          Não há nenhuma mensagem favoritada.
                        </Typography.H4>
                      </div>
                    </div>
                  )}
                </div>
                {/* <!-- MP RESULT --> */}
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
